import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Row, Col, Card, Button } from 'antd';
import { UnpaidFeeResultLineTextForm } from './../';

class UnpaidFeeSingleResultForm extends React.Component {
  /**
   * Creates a unpaid fee result line
   * @returns {*}
   */
  createNameElement = () => {
    if (this.props.unpaidFee.get('Firstname') != null) {
      return (
        <UnpaidFeeResultLineTextForm
          text={'Navn:'}
          value={`${this.props.unpaidFee.get('Firstname')} ${this.props.unpaidFee.get('Lastname')}`}
        />
      );
    } else if (this.props.unpaidFee.get('Lastname') != null) {
      return (
        <UnpaidFeeResultLineTextForm
          text={'Virksomhed:'}
          value={this.props.unpaidFee.get('Lastname')}
        />
      );
    } else {
      return null;
    }
  };

  render() {
    return this.props.unpaidFee.get('Value') === 4 ? (
      <label>Ingen opslag blev fundet.</label>
    ) : (
      <Card
        className={`result-card-${this.props.colorCode}`}
        title={this.props.cardTitle}
        style={{ animation: 'slide-down 0.4s ease' }}
        extra={
          <Button onClick={this.props.removeResultCard} type={'primary'} icon={<CloseOutlined />} />
        }
      >
        <div>
          {this.props.unpaidFee.get('Text') && (
            <Row>
              <Col span={24}>
                <div className={'result-card-body'}>{this.props.unpaidFee.get('Text')}</div>
              </Col>
            </Row>
          )}
          {this.props.unpaidFee.get('AKRnumber') && (
            <UnpaidFeeResultLineTextForm
              text={'AKR:'}
              value={this.props.unpaidFee.get('AKRnumber')}
            />
          )}
          {this.props.unpaidFee.get('CPRnumber') && (
            <UnpaidFeeResultLineTextForm
              text={'CPR:'}
              value={this.props.unpaidFee.get('CPRnumber')}
            />
          )}
          {this.props.unpaidFee.get('CVRnumber') && (
            <UnpaidFeeResultLineTextForm
              text={'CVR:'}
              value={this.props.unpaidFee.get('CVRnumber')}
            />
          )}
          {this.createNameElement()}
        </div>
      </Card>
    );
  }
}

export default UnpaidFeeSingleResultForm;
